export const GET_AGGREGATE_DATA_START = 'AggregateData/GET_AGGREGATE_DATA_START';
export const GET_AGGREGATE_DATA_SUCCESS = 'AggregateData/GET_AGGREGATE_DATA_SUCCESS';
export const GET_AGGREGATE_DATA_FAILURE = 'AggregateData/GET_AGGREGATE_DATA_FAILURE';

export const SEND_AGGREGATE_DATA_START = 'AggregateData/SEND_AGGREGATE_DATA_START';
export const SEND_AGGREGATE_DATA_SUCCESS = 'AggregateData/SEND_AGGREGATE_DATA_SUCCESS';
export const SEND_AGGREGATE_DATA_FAILURE = 'AggregateData/SEND_AGGREGATE_DATA_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/AggregateData/store/constants.js